import { useHistory } from 'react-router-dom';

function DetailPageLayout({ eyebrow, title, meta, children }) {
  const history = useHistory();

  return (
    <div className="detail-page">
      <button className="back-button" onClick={() => history.goBack()}>
        ← Back
      </button>

      <header className="detail-header">
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h1 className="heading-display">{title}</h1>
        {meta && meta.length > 0 && (
          <div className="detail-meta">
            {meta.map((item, i) => (
              <div key={i} className="detail-meta-item">
                <strong>{item.label}:</strong> {item.value}
              </div>
            ))}
          </div>
        )}
      </header>

      {children}
    </div>
  );
}

export function DetailSection({ title, children }) {
  return (
    <section className="detail-section">
      {title && <h3>{title}</h3>}
      {children}
    </section>
  );
}

export default DetailPageLayout;
